import { AccountantTuple } from 'types';

export enum TYPES {
  ACCOUNTANT_LOOKUP = '[ACCOUNTANT]-LOOKUP',
  ACCOUNTANT_LOOKUP_SUCCESS = '[ACCOUNTANT]-LOOKUP_SUCCESS',
  ACCOUNTANT_LOOKUP_FAILURE = '[ACCOUNTANT]-LOOKUP_FAILURE',
}

export type AccountantLookupActions = IAccountantLookup
  | IAccountantLookupSuccess
  | IAccountantLookupFailure

// =====================
// Accountant lookup - triggers saga
// =====================
export interface IAccountantLookup {
  type: typeof TYPES.ACCOUNTANT_LOOKUP;
  payload: {
    searchTerm: string;
  };
}

export function actionAccountantLookup(searchTerm: string): IAccountantLookup {
  return {
    type: TYPES.ACCOUNTANT_LOOKUP,
    payload: {
      searchTerm,
    },
  };
}

// =====================
// Accountant lookup - success
// =====================
export interface IAccountantLookupSuccess {
  type: typeof TYPES.ACCOUNTANT_LOOKUP_SUCCESS;
  payload: {
    accountantResults: AccountantTuple[];
  }
}

export function actionAccountantLookupSuccess(accountantResults: AccountantTuple[]): IAccountantLookupSuccess {
  return {
    type: TYPES.ACCOUNTANT_LOOKUP_SUCCESS,
    payload: {
      accountantResults,
    },
  };
}

// =====================
// Accountant lookup - failure
// =====================
export interface IAccountantLookupFailure {
  type: typeof TYPES.ACCOUNTANT_LOOKUP_FAILURE;
  payload: {
    error: string;
  };
}

export function actionAccountantLookupFailure(error: string): IAccountantLookupFailure {
  return {
    type: TYPES.ACCOUNTANT_LOOKUP_FAILURE,
    payload: {
      error,
    },
  };
}
